import { render, staticRenderFns } from "./layout-box.vue?vue&type=template&id=7f76cdb5&scoped=true"
import script from "./layout-box.vue?vue&type=script&lang=js"
export * from "./layout-box.vue?vue&type=script&lang=js"
import style0 from "./layout-box.vue?vue&type=style&index=0&id=7f76cdb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f76cdb5",
  null
  
)

export default component.exports